export const formatNumber = (value, decimals = 0) =>
  Number(value || 0).toLocaleString(undefined, { maximumFractionDigits: decimals });

export const formatCompactNumber = (value) => {
  const num = Number(value || 0);
  if (Math.abs(num) < 1000) return formatNumber(num);
  return Intl.NumberFormat(undefined, { notation: "compact", maximumFractionDigits: 1 })
    .format(num)
    .toLowerCase();
};
